export default __webpack_public_path__ + "static/ProValue_2@992-3e9ee1996d96f1565033bc37ab7dd358.png";